import { ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CALENDAR_LOCALE } from '../../services/constant';
import { TemplateService } from '../../services/template.service';
import { TranslateService } from '@ngx-translate/core';
var TaxReportComponent = (function () {
    function TaxReportComponent(apiService, modalService, cdr, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.cdr = cdr;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.currentPage = 1;
        this.loading = false;
        this.no_data = true;
        this.errorMsg = '';
        this.loadingExcel = false;
        this.confirm_loading = false;
        this.branchList = null;
        this.allBranchList = null;
        this.tableCol = [];
    }
    TaxReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
            _this.searchData();
        });
        this.loadTexts();
        this.searchData();
    };
    Object.defineProperty(TaxReportComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    TaxReportComponent.prototype.loadTexts = function () {
        var _this = this;
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('FILTER.DATE').subscribe(function (res) {
            _this.tableCol.push({ field: 'date', header: res }, { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, { field: 'start_end_document', header: _this.translate.instant('TABLE.DOCUMENT-NUMBER-START-END') }, { field: 'total_doc', header: _this.translate.instant('TABLE.NUMBER-DOCUMENTS') }, { field: 'total_missing_doc', header: _this.translate.instant('TABLE.NUMBER-MISSING-DOCUMENTS') }, { field: 'non_vat', header: _this.translate.instant('TABLE.SALES') + ' Non-VAT' }, { field: 'basis_amount', header: _this.translate.instant('TABLE.SALES') + ' VAT' }, { field: 'vat', header: 'VAT' });
            var documentData = _this.template.getDropdown();
            documentData[0] = { label: _this.translate.instant('COMMON.ALL'), value: null };
            _this.rdDocumentType = documentData;
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
            _this.loadInput();
        });
    };
    Object.defineProperty(TaxReportComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxReportComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    TaxReportComponent.prototype.ngAfterViewChecked = function () {
        this.cdr.detectChanges();
    };
    TaxReportComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) {
            console.log('error', error);
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedRdDocumentType = null;
    };
    TaxReportComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    TaxReportComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchData(params);
    };
    TaxReportComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    TaxReportComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    TaxReportComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    TaxReportComponent.prototype.canUserApproveDoc = function () {
        return this.authService.isAccountant();
    };
    TaxReportComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    TaxReportComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    TaxReportComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var data = {
            not_approved_only: this.notApprove,
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
            corporate_id: this.selectedCompany,
            branch_id: this.selectedBranch ? this.selectedBranch : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.postSaleTax(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    TaxReportComponent.prototype.confirmDocument = function (event, content, index) {
        document.getElementById('chkbox' + index).blur();
        event.preventDefault();
        this.modalData = this.tableData[index];
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
    };
    TaxReportComponent.prototype.confirm = function () {
        var _this = this;
        this.confirm_loading = true;
        var params = {
            approved: this.modalData.approved,
            header_issue_date: this.modalData.header_issue_date,
            group: this.modalData.group,
            document_type: this.modalData.document_type,
            rd_document_type: this.modalData.rd_document_type,
            corporate_branch: this.modalData.corporate_branch,
            header_invoice_numbers: this.modalData.header_invoice_numbers
        };
        this.apiService.approveSale(params).subscribe(function (result) {
            _this.confirm_loading = false;
            _this.modal.close();
            _this.modal = null;
        }, function (error) {
            _this.confirm_loading = false;
        });
    };
    TaxReportComponent.prototype.revertBack = function () {
        this.modalData.approved = !this.modalData.approved;
        this.modal.close();
        this.modal = null;
    };
    TaxReportComponent.prototype.clearData = function () {
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.branch = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allBranch = true;
        this.sortBy = null;
        this.sortMode = null;
        this.searchButtonClicked();
    };
    TaxReportComponent.prototype.getExportDocs = function (data, index) {
        var _this = this;
        this.tableData[index].loading_all_docs_excel = true;
        var params = {
            header_issue_dt: data.header_issue_date,
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            group: data.group,
        };
        this.apiService.getAllDocs(params).subscribe(function (obj) {
            _this.tableData[index].loading_all_docs_excel = false;
            var filename = 'daily_report ' + params.header_issue_dt + '.xlsx';
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.apiService.createDownloadFile(obj, filename);
        }, function (error) {
            _this.tableData[index].loading_all_docs_excel = false;
        });
    };
    TaxReportComponent.prototype.downloadMissingDocs = function (data, index) {
        var _this = this;
        this.tableData[index].loading_missing_docs_excel = true;
        var params = {
            header_issue_dt: data.header_issue_date,
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            max_document: data.max_document,
            min_document: data.min_document,
            group: data.group,
        };
        this.apiService.getMissingDoc(params).subscribe(function (obj) {
            _this.tableData[index].loading_missing_docs_excel = false;
            var filename = 'daily_missing ' + params.header_issue_dt + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
        }, function (error) {
            _this.tableData[index].loading_missing_docs_excel = false;
        });
    };
    TaxReportComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    TaxReportComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + errorMsgList.join(', ') + this.translate.instant('COMMON.CORRECT');
            return;
        }
    };
    TaxReportComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    TaxReportComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'SALES_TAX_REPORT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    TaxReportComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return TaxReportComponent;
}());
export { TaxReportComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.ts.pre-build-optimizer.js